export const extractDateIso = (label: string) => {
  const match = label.match(/\((\d{2})\/(\d{2})\/(\d{2})\)/)
  if (!match) return null

  const [, day, month, yy] = match

  const fullYear = `20${yy}`

  return `${fullYear}-${month}-${day}`
}
